export const PAGE_ID = 'requestForm';

export enum QueryKeys {
    EditReqeustPage = 'EditReqeustPage',
}
